import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./paymentlist.module.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Check, CreditCard, X } from "react-feather";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { RecordRefundButton, RefundChip, RefundDetails, RefundPaidAmount } from "./RefundParts";

const OnlinePayment = ({ item, index, taskExpanded, handleChange, setLoading, setSnackbarOpen, setSnackbarMsg, setAddCreditModalShow, setIsUpdate, setEditId, setDeleteModalShow, setDeleteId, setDeleteType }) => {
    const { getAccessTokenSilently } = useAuth0();

    const resendReceipt = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/resend-receipt/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<Accordion key={index} expanded={taskExpanded === "panel" + index} onChange={handleChange("panel" + index)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <div className={`${styles.NotesCard}`}>
                <div className={(item?.payment_status === 2 ? `${styles.RentRollDateSec} ${styles.Red}` : (item?.payment_status === 1 ? `${styles.RentRollDateSec} ${styles.Green}` : `${styles.RentRollDateSec} ${styles.Yellow}`))}>
                    <div className={`${styles.RentRollDate}`}>{dayjs(item?.date).format('MMM D')}</div>
                    <div className={`${styles.RentRollYear}`}>{dayjs(item?.date).format('YYYY')}</div>
                </div>
                <div className={(item?.payment_status === 2 ? `${styles.RentRollDesc} ${styles.Red}` : (item?.payment_status === 1 ? `${styles.RentRollDesc} ${styles.Green}` : `${styles.RentRollDesc} ${styles.Yellow}`))}>
                    <div className={`${styles.Top}`}>
                        <div className={`${styles.Badge}`}><CreditCard /></div>
                        <div className={`${styles.Title}`}>{item?.description}{(item?.payment_status === 2 ? ' - payment failed' : (item?.payment_status === 0 ? ' - payment pending' : ''))}</div>
                        <RefundChip item={item} />
                    </div>
                    <div className={`${styles.SubText}`}>{(item?.payment_details?.payment_method === 'us_bank_account' ? 'ACH Transfer' : (item?.payment_details?.payment_method === 'cashapp' ? 'Cash App Pay' : (item?.payment_details?.payment_method === 'card' ? 'Card Payment' : (item?.payment_details?.payment_method === 'klarna' ? 'Pay By Klarna' : 'Payment Received'))))}</div>
                </div>
                <div className={`${styles.RentRollDue}`}>
                    <div className={`${styles.DueEmpty}`}>—</div>
                </div>
                <div className={`${styles.RentRollPayment}`}>
                    {item?.payment_status === 0 && <div className={`${styles.PaymentPending}`}>
                        <div className={`${styles.Label}`}><Check /> Applied</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.amount)}</div>
                    </div>}

                    {item?.payment_status === 1 && <RefundPaidAmount item={item} />}

                    {item?.payment_status === 2 && <div className={`${styles.PaymentFaild}`}>
                        <div className={`${styles.Label}`}><X /> Failed</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.failed_amount)}</div>
                    </div>}
                </div>
                <div className={`${styles.RentRollBalance}`}>
                    {item?.balance_new > 0 && <div className={`${styles.BalanceOwnd}`}>
                        <div className={`${styles.Label}`}>Balance due</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.balance_new)}</div>
                    </div>}

                    {item?.balance_new === 0 && <div className={`${styles.BalanceZero}`}>
                        <div className={`${styles.Label}`}>Cleared</div>
                        <div className={`${styles.Amount}`}>$0.00</div>
                    </div>}

                    {item?.balance_new < 0 && <div className={`${styles.BalanceZero}`}>
                        <div className={`${styles.Label}`}>Over Paid</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.balance_new)}</div>
                    </div>}

                </div>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            <div className={`${styles.RentRollExpandSec}`}>
                <div className={`${styles.DetailsSec}`}>
                    <div className={`${styles.DetailsGrid}`}>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Payer</div>
                            <div className={`${styles.Text}`}>{item?.payment_details?.payer}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Memo</div>
                            <div className={`${styles.Text}`}>{item?.payment_details?.memo}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Amount</div>
                            <div className={`${styles.Text}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.payment_details?.amount)}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Stripe Charge</div>
                            <div className={`${styles.Text}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.payment_details?.stripe_charge)}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Type</div>
                            <div className={`${styles.Text}`}>One Time</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Status</div>
                            <div className={`${styles.Text}`}>{item?.payment_details?.status}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Sent On</div>
                            <div className={`${styles.Text}`}>{dayjs(item?.date).format("MMM D, YYYY")}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            {item?.payment_status === 0 && <>
                                <div className={`${styles.Label}`}>Estimated Deposit Date:</div>
                                <div className={`${styles.Text}`}>{dayjs(item?.date).add(3, 'day').format("MMM D, YYYY")}</div>
                            </>}
                            {item?.payment_status === 1 && <>
                                <div className={`${styles.Label}`}>Deposit Date:</div>
                                <div className={`${styles.Text}`}>{item?.payment_details?.settled_date ? dayjs(item?.payment_details?.settled_date).format("MMM D, YYYY") : dayjs(item?.payment_details?.updated_at).format("MMM D, YYYY")}</div>
                            </>}
                            {item?.payment_status === 2 && <>
                                {(item?.payment_details?.status === 'Disputed' ? <div className={`${styles.Label}`}>Disputed On:</div> : (item?.payment_details?.status === 'Refunded' ? <div className={`${styles.Label}`}> Refunded On:</div> : <div className={`${styles.Label}`}>Failed On:</div>))}
                                <div className={`${styles.Text}`}>{item?.payment_details?.settled_date ? dayjs(item?.payment_details?.settled_date).format("MMM D, YYYY") : dayjs(item?.payment_details?.updated_at).format("MMM D, YYYY")}</div>
                            </>}
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Method</div>
                            {item?.payment_details?.payment_method === "us_bank_account" && <div className={`${styles.Text}`}>ACH Bank Transfer</div>}
                            {item?.payment_details?.payment_method === "cashapp" && <div className={`${styles.Text}`}>Cash App Pay</div>}
                            {item?.payment_details?.payment_method === "card" && <div className={`${styles.Text}`}>Card Payment</div>}
                            {item?.payment_details?.payment_method === "klarna" && <div className={`${styles.Text}`}>Pay By Klarna</div>}
                        </div>
                        {item?.payment_details?.status === "Failed" && <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Failure Message</div>
                            <div className={`${styles.Text}`}>{item?.payment_details?.failure_message}</div>
                        </div>}
                        {item?.payment_status === 2 && item?.payment_details?.status === "Refunded" && <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Refunded Amount</div>
                            <div className={`${styles.Text}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.payment_details?.refund_amount)}</div>
                        </div>}
                    </div>
                </div>
                <RefundDetails item={item} />
                <div className={`${styles.ButtonSec}`}>
                    {item?.payment_status === 1 && <button className={`${styles.Button} ${styles.Blue}`} onClick={(e) => resendReceipt()}>Resend Receipt</button>}
                    <RecordRefundButton item={item} />
                </div>
            </div>
        </AccordionDetails >
    </Accordion >);
}

export default OnlinePayment;